module.exports = __webpack_public_path__ + "img/skybridge.cee26bb4.svg";